<template src="./shipment.pug" lang="pug"></template>

<script>
  import boxComponent from './box/box';
  import productComponent from './product/product';
  import modalCreateBox from '@/components/modals/create_box/create_box';
  import DeleteModal from '@/components/modals/delete';

  export default {
    props: {
      shipment: Object,
      allowActions: { type: Boolean, default: false },
      afterCreate: { type: Function, default: null },
    },
    data() {
      return {
        modal_shipment: false,
        deleteModal: false,
        deletingBox: null,
      };
    },
    components: {
      box_component: boxComponent,
      product_component: productComponent,
      modalCreateBox,
      DeleteModal,
    },
    computed: {
      isStorageSection() {
        return this.$store.getters.get_app_section === 'storage';
      },
      selected() {
        return this.shipment.products.filter((product) => product.selected) || [];
      },
      isSelectedAll() {
        return this.selected.length === this.shipment.products.length;
      },
    },
    methods: {
      toggleSelectAll() {
        const selected = !this.isSelectedAll;
        this.shipment.products.forEach((product) => this.$set(product, 'selected', selected));
      },
      showCreateBoxModel() {
        this.modal_shipment = true;
      },
      showDeleteModal() {
        this.deleteModal = true;
      },
      deleteShipment() {
        if (!this.deleteModal) return;
        this.$store.dispatch('shipments/delete', { id: this.shipment.id })
          .then(() => {
            this.deleteModal = false;
            this.afterCreate();
            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Shipment was deleted.' });
          })
          .catch(() => {
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Shipment wasn\'t deleted. Please try again.' });
          });
      },
      deleteBox() {
        if (!this.deletingBox) return;
        this.$store.dispatch('boxes/delete', { id: this.deletingBox })
          .then(() => {
            this.deletingBox = false;
            this.afterCreate();
            this.$store.dispatch('nt_set_notification',
              { type: 'inform', message: 'Box was deleted.' });
          })
          .catch((err) => {
            console.log(err);
            this.$store.dispatch('nt_set_notification',
              { type: 'error', message: 'Box wasn\'t deleted. Please try again.' });
          });
      },
    },
  };
</script>
